import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import ChatLineIcon from '../../../assets/image/chat-line.svg';
import {
  isZendeskMessagingEnabled,
  ZendeskUnreadState
} from '../../../integrations/zendeskMessaging';
import ChatUnreadBadge, {
  formatChatControlLabel
} from '../ChatUnreadBadge';
import {
  ChatFooter,
  ChatFooterIcon,
  ChatFooterLink
} from './styles';

interface ChatFooterActionProps {
  collapsed: boolean;
  handleHideNavbar: () => void;
  enabled?: boolean;
  unread?: ZendeskUnreadState;
  onOpenFromUnread?: () => void;
}

const UNKNOWN_UNREAD: ZendeskUnreadState = { status: 'unknown', count: null };

const ChatFooterAction = forwardRef<HTMLAnchorElement, ChatFooterActionProps>(({
  collapsed,
  handleHideNavbar,
  enabled = isZendeskMessagingEnabled,
  unread = UNKNOWN_UNREAD,
  onOpenFromUnread = () => undefined
}, ref) => {
  const intl = useIntl();
  if (!enabled) return null;

  const accessibleLabel = formatChatControlLabel(intl, unread);
  const visibleLabel = intl.formatMessage({ id: 'chat.title' });

  return (
    <ChatFooter $collapsed={collapsed} data-testid='chat-footer-action'>
      <ChatFooterLink
        ref={ref}
        to='/chat'
        aria-label={accessibleLabel}
        className={({ isActive }) => isActive ? 'active' : ''}
        onClick={() => {
          onOpenFromUnread();
          handleHideNavbar();
        }}
      >
        <ChatFooterIcon aria-hidden='true'>
          <img data-testid='chat-bubble-icon' src={ChatLineIcon} alt='' />
        </ChatFooterIcon>
        {!collapsed && <span>{visibleLabel}</span>}
        <ChatUnreadBadge unread={unread} />
      </ChatFooterLink>
    </ChatFooter>
  );
});

ChatFooterAction.displayName = 'ChatFooterAction';

export default ChatFooterAction;
